const points = [
    {
        n: "01",
        title: "Quick Response",
        desc: "Our staff replies fast, handles bookings smoothly and confirms itineraries with zero stress — day or night.",
    },
    {
        n: "02",
        title: "Good Value",
        desc: "Packages and deals designed to fit real budgets, with fair and transparent pricing you can trust.",
    },
    {
        n: "03",
        title: "Helpful Staff",
        desc: "A genuinely friendly team, always ready to assist with the smallest detail of your journey.",
    },
    {
        n: "04",
        title: "11 Years of Trust",
        desc: "Over a decade serving Shivamogga travellers, earning a spotless 5.0-star reputation.",
    },
];

const WhyUs = () => {
    return (
        <section id="why" className="mx-auto max-w-7xl px-5 md:px-10 py-24">
            <div className="max-w-3xl">
                <p className="text-xs uppercase tracking-[0.28em] text-[#C46A42] font-medium">
                    Why travellers choose us
                </p>
                <h2 className="font-display text-4xl md:text-6xl text-[#1B3B2B] mt-3 leading-[1.05]">
                    A reputation built one happy trip at a time.
                </h2>
            </div>
            <div className="mt-14 grid gap-x-10 gap-y-12 md:grid-cols-2">
                {points.map((p, i) => (
                    <div key={i} className="flex gap-6">
                        <div className="font-display text-4xl text-[#C46A42]/70 tabular-nums">
                            {p.n}
                        </div>
                        <div>
                            <h3 className="font-display text-2xl text-[#1B3B2B]">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-[#4B5563] leading-relaxed">
                                {p.desc}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WhyUs;
